module.exports = __webpack_public_path__ + "img/IMG_8981_L_Foamcore_MockedUp.2f7d7a6e.jpg";